<template>
  <div>
    <Imports type="customers" />
  </div>
</template>

<script
  setup
  lang="ts"
>
import Imports from '@/modules/_shared/imports/index.vue';
</script>
